import {t,format} from '../i18n.js';
export function initHeader({ gsap, motion, menuArrows, scope }) {
  const document=scope.document;
  const window=scope.ownerDocument.defaultView;
  const matchMedia=window.matchMedia.bind(window);
  document.querySelectorAll('[data-block="header"]').forEach((header) => {
    const toggle = header.querySelector(".aw-menu-toggle");
    const menu = header.querySelector(".aw-menu");
    if (!toggle || !menu) return;
    let open = false,
      oldOverflow = "";
    const siblings = [
      document.querySelector("main"),
      document.querySelector("footer"),
    ].filter(Boolean);
    const items = [
      ...menu.querySelectorAll("nav li"),
      ...menu.querySelectorAll(".aw-menu__aside > *"),
    ];
    const finishClose = () => {
      if (open) return;
      menuArrows.reset(menu);
      menu.hidden = true;
      menu.inert = false;
      header.classList.remove("is-open");
      header.removeAttribute("role");
      header.removeAttribute("aria-modal");
      header.removeAttribute("aria-label");
      siblings.forEach((n) => (n.inert = false));
      document.body.style.overflow = oldOverflow;
    };
    // One reversible timeline preserves position/velocity on a rapid second click.
    const timeline = gsap.timeline({
      paused: true,
      onReverseComplete: finishClose,
    });
    timeline
      .fromTo(
        menu,
        { clipPath: "polygon(0 0,100% 0,100% 0,0 0)" },
        {
          clipPath: "polygon(0 0,100% 0,100% 100%,0 100%)",
          duration: 0.8,
          ease: "power3.inOut",
        },
        0,
      )
      .fromTo(
        items,
        { y: 32, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.55,
          stagger: 0.045,
          ease: "power3.out",
        },
        0.25,
      );
    const setOpen = (value) => {
      if (open === value) return;
      open = value;
      toggle.setAttribute("aria-expanded", String(open));
      toggle.setAttribute("aria-label", open ? t("Zamknij menu") : t("Otwórz menu"));
      if (open) {
        if (menu.hidden) oldOverflow = document.body.style.overflow;
        header.classList.add("is-open");
        header.setAttribute("role", "dialog");
        header.setAttribute("aria-modal", "true");
        header.setAttribute("aria-label", t("Menu strony"));
        menu.hidden = false;
        menu.inert = false;
        siblings.forEach((n) => (n.inert = true));
        document.body.style.overflow = "hidden";
        if (motion.enabled) timeline.timeScale(1).play();
        else timeline.progress(1).pause();
        // The toggle keeps focus so the next Tab enters the links naturally.
      } else {
        menu.inert = true;
        toggle.focus({ preventScroll: true });
        if (motion.enabled && timeline.progress() > 0)
          timeline.timeScale(1.2).reverse();
        else {
          timeline.progress(0).pause();
          finishClose();
        }
      }
    };
    scope.on(toggle, "click", () => setOpen(!open));
    scope.on(document, "keydown", (e) => {
      if (!open) return;
      if (e.key === "Escape") {
        e.preventDefault();
        setOpen(false);
      }
      if (e.key === "Tab") {
        const focusables = [
          ...header.querySelectorAll("a[href],button:not(:disabled)"),
        ].filter((n) => n.getClientRects().length);
        const first = focusables[0],
          last = focusables.at(-1);
        if (
          e.shiftKey &&
          (document.activeElement === first ||
            !header.contains(document.activeElement))
        ) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
    menu
      .querySelectorAll("a:not([data-placeholder])")
      .forEach((a) => scope.on(a, "click", () => setOpen(false)));
    scope.on(document, "aw:motionchange", () => {
      timeline.pause().progress(open ? 1 : 0);
      if (!open) finishClose();
    });
    scope.onDispose(()=>{open=false;timeline.kill();finishClose();toggle.setAttribute("aria-expanded","false");});
  });
}
